import React from "react";
import event1 from "../../assets/images/events/event1.jpeg";
import event2 from "../../assets/images/events/event2.jpeg";
import event3 from "../../assets/images/events/event3.jpeg";
import { motion } from "framer-motion";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCalendarAlt,
  faClock,
  faBolt,
} from "@fortawesome/free-solid-svg-icons";

const fadeUp = {
  hidden: { opacity: 0, y: 32 },
  visible: (i = 0) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.65, delay: i * 0.12, ease: [0.22, 1, 0.36, 1] },
  }),
};

const events = [
  {
    id: 1,
    title: "ورشة عمل تفاعلية",
    description: "انضم إلينا في ورشة عمل مكثفة حول أحدث تقنيات التعليم.",
    date: "10 اكتوبر 2025",
    time: "10:00 صباحاً",
    image: event3,
    tag: "ورشة عمل",
    accent: "#6366f1",
    soft: "#fffbeb",
  },
  {
    id: 2,
    title: "ندوة تعليمية",
    description: "ندوة خاصة لمناقشة مستقبل التعليم الإلكتروني.",
    date: "18 اكتوبر 2025",
    time: "10:00 صباحاً",
    image: event2,
    tag: "ندوة",
    accent: "#2563eb",
    soft: "#eff6ff",
  },
  {
    id: 3,
    title: "ملتقى الطلاب",
    description: "فرصة رائعة للتواصل مع زملائك وتبادل الخبرات.",
    date: "25 اكتوبر 2025",
    time: "10:00 صباحاً",
    image: event1,
    tag: "ملتقى",
    accent: "#059669",
    soft: "#f0fdf4",
  },
];

const LiveEvent = () => {
  return (
    <section className="lv-root" id="events">
      <div className="lv-container">

        {/* ── header ── */}
        <motion.div
          className="lv-header"
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.3 }}
        >
          <motion.div className="lv-eyebrow" variants={fadeUp} custom={0}>
            <span className="lv-eyebrow-dot" />
            الفعاليات المباشرة
          </motion.div>
          <motion.h2 className="lv-title" variants={fadeUp} custom={1}>
            انضم إلينا في <em>أحداثنا المباشرة</em>
          </motion.h2>
          <motion.p className="lv-subtitle" variants={fadeUp} custom={2}>
            تعلم من الخبراء واكتسب مهارات جديدة في فعالياتنا التفاعلية
          </motion.p>
        </motion.div>

        {/* ── featured card ── */}
        <motion.div
          className="lv-featured"
          initial={{ opacity: 0, y: 36 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.2 }}
          transition={{ duration: 0.65, ease: [0.22, 1, 0.36, 1] }}
          whileHover="hover"
        >
          <div className="lv-featured-img-box">
            <img src={event3} alt="مؤتمر التعليم الرقمي" className="lv-featured-img" />
            <div className="lv-featured-img-overlay" />
            <span className="lv-featured-tag">
              <FontAwesomeIcon icon={faBolt} />
              حدث مميز
            </span>
          </div>
          <div className="lv-featured-body">
            <h3 className="lv-featured-title">مؤتمر التعليم الرقمي 2025</h3>
            <p className="lv-featured-desc">
              نخبة من الخبراء والمتخصصين في مجال التعليم الإلكتروني لمناقشة أحدث الاتجاهات والتقنيات. فرصة رائعة للتواصل والتعلم واكتساب مهارات جديدة.
            </p>
            <div className="lv-featured-meta">
              <span className="lv-meta-chip">
                <FontAwesomeIcon icon={faCalendarAlt} />
                10 اكتوبر 2025
              </span>
              <span className="lv-meta-chip">
                <FontAwesomeIcon icon={faClock} />
                10:00 صباحاً
              </span>
            </div>
          </div>
          <motion.div
            className="lv-featured-bar"
            variants={{ rest: { opacity: 0 }, hover: { opacity: 1 } }}
            transition={{ duration: 0.3 }}
          />
        </motion.div>

        {/* ── cards grid ── */}
        <motion.div
          className="lv-grid"
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.1 }}
        >
          {events.map((ev, i) => (
            <motion.article
              key={ev.id}
              className="lv-card"
              variants={fadeUp}
              custom={i}
              whileHover="hover"
              initial="rest"
              animate="rest"
            >
              {/* image */}
              <div className="lv-card-img-box">
                <img src={ev.image} alt={ev.title} className="lv-card-img" />
                <div className="lv-card-img-overlay" />
                <span
                  className="lv-card-tag"
                  style={{ background: ev.soft, color: ev.accent }}
                >
                  {ev.tag}
                </span>
              </div>

              {/* body */}
              <div className="lv-card-body">
                <h3 className="lv-card-title">{ev.title}</h3>
                <p className="lv-card-desc">{ev.description}</p>

                <div className="lv-card-divider" />

                <div className="lv-card-footer">
                  <div className="lv-card-meta">
                    <span className="lv-card-meta-item" style={{ color: ev.accent }}>
                      <FontAwesomeIcon icon={faCalendarAlt} />
                      {ev.date}
                    </span>
                    <span className="lv-card-meta-item">
                      <FontAwesomeIcon icon={faClock} />
                      {ev.time}
                    </span>
                  </div>
                </div>
              </div>

              {/* accent bar */}
              <motion.div
                className="lv-card-bar"
                style={{ background: ev.accent }}
                variants={{ rest: { opacity: 0 }, hover: { opacity: 1 } }}
                transition={{ duration: 0.3 }}
              />
            </motion.article>
          ))}
        </motion.div>

      </div>

      <style>{`
        /* ── root ── */
        .lv-root {
            font-family: "Zain", sans-serif;
          direction: rtl;
          position: relative;
          padding: 120px 0 100px;
          background: #fff;
          overflow: hidden;
          isolation: isolate;
        }

        /* ── container ── */
        .lv-container {
          position: relative; z-index: 2;
          max-width: 1260px; margin: 0 auto; padding: 0 40px;
        }
        @media(min-width:1200px){ .lv-container { padding: 0 60px; } }

        /* ── header ── */
        .lv-header { text-align: center; margin-bottom: 72px; }

        .lv-eyebrow {
          display: inline-flex; align-items: center; gap: 10px;
          color: #6366f1; font-weight: 800; font-size: 0.82rem;
          letter-spacing: 0.15em; text-transform: uppercase; margin-bottom: 22px;
        }
        .lv-eyebrow-dot {
          width: 8px; height: 8px; border-radius: 50%; background: #6366f1;
          animation: lv-pulse 2.2s ease-in-out infinite;
        }
        @keyframes lv-pulse {
          0%,100%{ box-shadow: 0 0 0 0 rgba(232,146,10,0.45); }
          50%{ box-shadow: 0 0 0 9px rgba(232,146,10,0); }
        }
        .lv-title {
          font-size: clamp(2.2rem, 4vw, 3.6rem);
          font-weight: 900; color: #0f172a;
          margin: 0 0 18px; line-height: 1.2;
          letter-spacing: -0.025em;
        }
        .lv-title em {
          font-style: normal;
          background: linear-gradient(90deg, #6366f1 0%, #6366f1 55%, #6366f1 100%);
          -webkit-background-clip: text; -webkit-text-fill-color: transparent;
          background-clip: text;
        }
        .lv-subtitle {
          font-size: 1.08rem; color: #64748b; line-height: 1.85; margin: 0;
        }

        /* ── featured ── */
        .lv-featured {
          position: relative;
          display: grid;
          grid-template-columns: 44% 1fr;
          border-radius: 24px;
          border: 1px solid rgba(15,23,42,0.08);
          background: #fff;
          overflow: hidden;
          margin-bottom: 24px;
          cursor: pointer;
          transition: border-color 0.3s, box-shadow 0.3s;
        }
        .lv-featured:hover {
          border-color: rgba(15,23,42,0.15);
          box-shadow: 0 16px 48px rgba(15,23,42,0.1);
        }
        @media(max-width:900px){
          .lv-featured { grid-template-columns: 1fr; }
        }

        .lv-featured-img-box {
          position: relative;
          min-height: 340px;
          overflow: hidden;
        }
        .lv-featured-img {
          width: 100%; height: 100%;
          object-fit: cover;
          transition: transform 0.7s ease;
        }
        .lv-featured:hover .lv-featured-img { transform: scale(1.06); }
        .lv-featured-img-overlay {
          position: absolute; inset: 0;
          background: linear-gradient(to left, rgba(15,23,42,0.18), transparent);
        }
        .lv-featured-tag {
          position: absolute; top: 16px; right: 16px;
          display: inline-flex; align-items: center; gap: 6px;
          background: rgba(255,255,255,0.95);
          backdrop-filter: blur(6px);
          color: #6366f1; font-weight: 800; font-size: 0.82rem;
          padding: 5px 14px; border-radius: 30px;
          box-shadow: 0 4px 12px rgba(0,0,0,0.1);
        }

        .lv-featured-body {
          padding: 40px 36px;
          display: flex; flex-direction: column; justify-content: center;
          gap: 0;
        }
        .lv-featured-title {
          font-size: clamp(1.5rem, 2.5vw, 2rem);
          font-weight: 900; color: #0f172a;
          margin: 0 0 16px; line-height: 1.25;
        }
        .lv-featured-desc {
          font-size: 1rem; color: #64748b;
          line-height: 1.8; margin: 0 0 24px;
        }
        .lv-featured-meta {
          display: flex; flex-wrap: wrap; gap: 10px;
        }
        .lv-meta-chip {
          display: inline-flex; align-items: center; gap: 7px;
          background: #f8fafc;
          border: 1px solid rgba(15,23,42,0.07);
          border-radius: 10px; padding: 7px 14px;
          font-size: 0.88rem; font-weight: 700; color: #475569;
        }

        /* featured accent bar at bottom */
        .lv-featured-bar {
          position: absolute; bottom: 0; left: 0; right: 0;
          height: 3px;
          background: linear-gradient(90deg, #6366f1, #6366f1);
        }

        /* ── grid ── */
        .lv-grid {
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          gap: 20px;
        }
        @media(max-width:1080px){ .lv-grid { grid-template-columns: repeat(2,1fr); } }
        @media(max-width:640px){ .lv-grid { grid-template-columns: 1fr; } }

        /* ── card ── */
        .lv-card {
          position: relative;
          border-radius: 24px;
          border: 1px solid rgba(15,23,42,0.08);
          background: #fff;
          overflow: hidden;
          cursor: pointer;
          display: flex;
          flex-direction: column;
          transition: border-color 0.3s, box-shadow 0.3s;
        }
        .lv-card:hover {
          border-color: rgba(15,23,42,0.15);
          box-shadow: 0 16px 40px rgba(15,23,42,0.1);
        }

        /* image */
        .lv-card-img-box {
          position: relative;
          height: 220px;
          overflow: hidden;
          background: #f1f5f9;
        }
        .lv-card-img {
          width: 100%; height: 100%;
          object-fit: cover;
          transition: transform 0.7s ease;
        }
        .lv-card:hover .lv-card-img { transform: scale(1.07); }
        .lv-card-img-overlay {
          position: absolute; bottom: 0; left: 0; right: 0;
          height: 45%;
          background: linear-gradient(to top, rgba(15,23,42,0.4), transparent);
        }
        .lv-card-tag {
          position: absolute; top: 14px; right: 14px;
          padding: 4px 12px; border-radius: 20px;
          font-size: 0.78rem; font-weight: 800;
        }

        /* body */
        .lv-card-body {
          padding: 22px 20px 18px;
          display: flex; flex-direction: column; flex: 1;
        }
        .lv-card-title {
          font-size: 1.2rem; font-weight: 900;
          color: #0f172a; margin: 0 0 10px; line-height: 1.3;
        }
        .lv-card-desc {
          font-size: 0.92rem; color: #64748b;
          line-height: 1.75; margin: 0 0 16px; flex: 1;
        }
        .lv-card-divider {
          height: 1px; background: rgba(15,23,42,0.06);
          margin-bottom: 16px;
        }

        /* footer */
        .lv-card-footer {
          display: flex; align-items: center; justify-content: space-between; gap: 8px;
        }
        .lv-card-meta {
          display: flex; flex-direction: column; gap: 4px;
        }
        .lv-card-meta-item {
          display: inline-flex; align-items: center; gap: 6px;
          font-size: 0.8rem; font-weight: 700; color: #94a3b8;
        }
        .lv-card-btn {
          display: inline-flex; align-items: center; gap: 7px;
          background: transparent;
          border: 1px solid;
          border-radius: 10px; padding: 8px 14px;
          font-family: inherit; font-weight: 700; font-size: 0.84rem;
          cursor: pointer;
          transition: background 0.2s;
          white-space: nowrap;
        }
        .lv-card-btn:hover { background: rgba(15,23,42,0.03); }

        /* accent bar */
        .lv-card-bar {
          height: 3px; width: 100%; flex-shrink: 0;
        }

        @media(max-width:768px){
          .lv-root { padding: 90px 0 64px; }
          .lv-container { padding: 0 20px; }
          .lv-header { margin-bottom: 52px; }
          .lv-featured-body { padding: 28px 24px; }
          .lv-featured-img-box { min-height: 240px; }
        }
      `}</style>
    </section>
  );
};

export default LiveEvent;
